'use strict';


var Storage = null;


if ( PLATFORM === 'MAG' || NANOCORE ) {
    Storage = require('../platforms/mag/storage');
}
if ( PLATFORM === 'SMARTTV' ) {
    Storage = require('../platforms/smarttv/storage');
}
if ( PLATFORM === 'TIZEN' ) {
    Storage = require('../platforms/smarttv/storage');
}
if ( PLATFORM === 'WEBOS' ) {
    Storage = require('../platforms/smarttv/storage');
}
if ( PLATFORM === 'BROWSER' ) {
    Storage = require('../platforms/browser/storage');
}

module.exports = Storage;
